import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=0f1584cf&scoped=true&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1584cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1584cf')) {
      api.createRecord('0f1584cf', component.options)
    } else {
      api.reload('0f1584cf', component.options)
    }
    module.hot.accept("./DashboardNavbar.vue?vue&type=template&id=0f1584cf&scoped=true&", function () {
      api.rerender('0f1584cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Dashboard/partials/DashboardNavbar.vue"
export default component.exports